export default {"src":"/_next/static/media/hotline24_24.8ef617f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};